import { Badge, Button } from "~/components/design-system/components"

/**
 * Where dates or stores come from, a folder ("From AW26") or the package or
 * subfolder itself ("Own dates"), with the button that switches between them.
 */
export function InheritanceSource({
  from,
  ownLabel,
  actionLabel,
  actionTitle,
  disabled,
  disabledReason,
  onAction,
}: {
  /** The folder it follows; undefined when it sets its own. */
  from: string | undefined
  ownLabel: string
  actionLabel: string
  actionTitle: string
  disabled: boolean
  /** Shown as the tooltip while the switch can't be used. */
  disabledReason?: string
  onAction: () => void
}) {
  return (
    <div className="flex items-center gap-2" onClick={(event) => event.stopPropagation()}>
      <Badge variant={from === undefined ? "violet" : "neutral"}>
        {from === undefined ? ownLabel : `From ${from}`}
      </Badge>
      <Button
        variant="transparent"
        size="sm"
        requires="edit"
        allowedTitle={disabledReason ?? actionTitle}
        disabled={disabled || disabledReason !== undefined}
        onClick={onAction}
      >
        {actionLabel}
      </Button>
    </div>
  )
}
